import { render, staticRenderFns } from "./DeleteGradingTable.vue?vue&type=template&id=68044a62&"
import script from "./DeleteGradingTable.vue?vue&type=script&lang=js&"
export * from "./DeleteGradingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports